export const stripWrappingTag = (html: string) => html.replace(/^<[^>]+>|<\/[^>]+>$/g, "");
